<template>
    <fieldset :disabled="loading">
        <div v-if="!data" class="text-muted text-center" style="padding:100px 0;">
            {{ translate('loading') }} <spinner></spinner>
        </div>
        <div v-else class="roundbox">
            <div class="rbcontent head">
                <h2>{{ data.Subject }}</h2>
            </div>
            <div class="row no-gutters job-container">
                <div class="col">
                    <div class="rbcontent">
                        <table class="table table-borderless table-sm ozet">
                            <tbody>
                                <tr>
                                    <td style="width:150px;">{{ translate('incomingDocumentList.sentDate') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td>{{ data.SentDate | datetime }}</td>
                                </tr>
                                <tr>
                                    <td style="width:150px;">{{ translate('uetsInbox.uetsFrom') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td><span style="font-weight:bold;">{{ data.FromName }}</span> - {{ data.From }}</td>
                                </tr>
                                <tr>
                                    <td style="width:150px;">{{ translate('uetsInbox.uetsTo') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td><span style="font-weight:bold;">{{ data.ToName }}</span> - {{ data.To }}</td>
                                </tr>
                                <tr>
                                    <td style="width:150px;">{{ translate('uetsInbox.messageId') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td>{{ data.MessageId }}</td>
                                </tr>
                                <tr>
                                    <td style="width:150px;">{{ translate('uetsInbox.referenceId') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td>{{ data.ReferenceId }}</td>
                                </tr>
                                <tr>
                                    <td style="width:150px;">{{ translate('uetsInbox.document') }}</td>
                                    <td style="width:1px;">:</td>
                                    <td><file-download-link :document="data.Document" @download="downloadDocument"
                                            @preview="showFilePreview"></file-download-link></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="rbcontent footer">
                <div class="row">
                    <div class="col">
                        <button type="button" accesskey="g" v-on:click="$router.push({name: 'UetsList'})" class="btn btn-outline-primary">{{
                            translate('goBack') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div style="position:relative; display: block; z-index: 999999;">
            <file-preview v-if="fileDetail" :file="fileDetail" :viewer="viewerType"
                @close="fileDetail = null;"></file-preview>
        </div>
    </fieldset>
</template>
<script>
import formMixin from '../formMixin.js';
import axios from 'axios';
import filePreview from '../components/FilePreview.vue';
import fileDownloadLink from '../components/FileDownloadLink.vue'
import spinner from '@/components/Spinner.vue'

export default {
    mixins: [formMixin],
    components: {
        filePreview,
        fileDownloadLink,
        spinner
    },
    created() {
        this.getData(this.$route.params.id).then(() => {
            console.log(this.data)
        })
    },
    data() {
        return {
            loading: false,
            modelName: 'UetsBox',
            data: null,
            fileDetail: null,           // Önizlemesi görüntülenecek dosya
        };
    },
    methods: {
        showFilePreview(document, type) {
            this.fileDetail = document;
            this.viewerType = type;
            this.fileDetail.EntityId = this.data.Id;
            this.fileDetail.EntityType = "Uets";
        },
        downloadDocument(document, menuKey) {
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
                .post(`/uetsBox/createDocumentUrl/`, {
                    EntityId: this.data.Id,
                    DocumentId: document.Id,
                })
                .then(x => {
                    console.log("createDocumentUrl Result:", x.data);
                    window.open(x.data.Data.Url + (menuKey == 'view' ? "&view=true" : ""));
                })
                .catch(x => window.processErrorResponse(x, this));
        },
    }
}
</script>

<style scoped></style>